import {useEffect, useState} from "react";
import {useSearchParams} from "react-router";
import {debounce} from "../../utils";
import "./Searchbar.scss"

interface UpdateContext {
    init: () => any
    q: string
    searchParams: URLSearchParams
    setSearchParams: (p: URLSearchParams) => any
}

const updateUrlQuery: (c: UpdateContext) => any = debounce((c: UpdateContext) => {
    if (!c.q || c.q.length > 3) {
        c.init()
        if (c.q) {
            c.searchParams.set('q', c.q)
        } else {
            c.searchParams.delete('q')
        }

        c.searchParams.set('f', 'on')
        if (Boolean(c.searchParams.get('page'))) {
            c.searchParams.set('page', '1')
        }

        c.setSearchParams(c.searchParams)
    }
}, 1500)

interface SearchbarProps {
    placeholder?: string
}

function Searchbar({placeholder = ""}: SearchbarProps) {
    const [searchParams, setSearchParams] = useSearchParams()
    const [query, setQuery] = useState(searchParams.get('q') || '')
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        setQuery(searchParams.get('q') || '')
        setDisabled(false)
    }, [searchParams])

    return <>
        <div className="cmp-searchbar control has-icons-right">
            <input
                className={`input is-small is-primary is-rounded ${disabled ? 'is-disabled' : ''}`}
                type="text"
                style={{width: '20em'}}
                placeholder={`${placeholder} (min. 4 Zeichen)`}
                value={query}
                onChange={e => {
                    if (!disabled) {
                        setQuery(e.target.value)
                        updateUrlQuery({
                            init: () => setDisabled(true),
                            q: e.target.value,
                            searchParams: searchParams,
                            setSearchParams: setSearchParams
                        })
                    }
                }}
            />
            <span className="icon is-small is-right">
                <span className="material-symbols-outlined">search</span>
            </span>
        </div>
    </>
}

export {
    Searchbar
}
